import { Fab, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { motion } from 'framer-motion'

export const WhatsAppButton = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  
  const whatsappNumber = '+923448252109' // Your WhatsApp number
  const whatsappMessage = 'Hello! I would like to inquire about your products.'
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace('+', '')}?text=${encodeURIComponent(whatsappMessage)}`

  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 0.3, type: 'spring' }}
      style={{
        position: 'fixed',
        bottom: isMobile ? '20px' : '30px',
        right: isMobile ? '20px' : '30px',
        zIndex: 40
      }}
    >
      <Tooltip title="Contact us on WhatsApp">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {!isMobile && (
          <Typography
            sx={{
              bgcolor: 'white',
              color: '#111',
              px: 1.5,
              py: 0.8,
              borderRadius: '6px',
              fontWeight: 700,
              boxShadow: '0 6px 18px rgba(0,0,0,0.14)',
              whiteSpace: 'nowrap'
            }}
          >
            Live chat
          </Typography>
        )}
        <Fab
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            backgroundColor: '#25D366',
            color: 'white',
            '&:hover': {
              backgroundColor: '#1da851',
              boxShadow: '0 8px 16px rgba(37, 211, 102, 0.4)'
            },
            animation: 'pulse 2s infinite',
            '@keyframes pulse': {
              '0%': {
                boxShadow: '0 0 0 0 rgba(37, 211, 102, 0.7)'
              },
              '70%': {
                boxShadow: '0 0 0 10px rgba(37, 211, 102, 0)'
              },
              '100%': {
                boxShadow: '0 0 0 0 rgba(37, 211, 102, 0)'
              }
            }
          }}
        >
          <WhatsAppIcon sx={{ fontSize: '2rem' }} />
        </Fab>
        </div>
      </Tooltip>
    </motion.div>
  )
}
